import { format } from "date-fns";
import { OverallPerformance } from "../types/results";
import api from "./api";

export const listResults = async (
  startDate: Date,
  endDate: Date
): Promise<OverallPerformance> => {
  const objectParamsRequest = {
    filtroDataInicio: format(startDate, "yyyy-MM-dd"),
    filtroDataFim: format(endDate, "yyyy-MM-dd"),
    grupoCampanha: "CONCLUIDO",
    automacao: 0,
  };
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/performance/getPerformanceMes",
    { params: objectParamsRequest }
  );

  return response.data;
};

export const listRescueCampaign = async (
  startDate: Date,
  endDate: Date,
  id?: number
): Promise<{ detalhe: any[]; lista: any[] }> => {
  const objectParamsRequest = {
    filtroDataInicio: format(startDate, "yyyy-MM-dd"),
    filtroDataFim: format(endDate, "yyyy-MM-dd"),
    grupoCampanha: "CONCLUIDO",
    idCampanha: id,
  };
  const response = await api.get(
    "sms-p1-:stage/:stage/crm/getResgateCampanha",
    {
      params: objectParamsRequest,
    }
  );

  return response.data;
};

export const listProfilesCampaign = async (
  startDate: Date,
  endDate: Date,
  id: number
): Promise<any[]> => {
  const objectParamsRequest = {
    filtroDataInicio: format(startDate, "yyyy-MM-dd"),
    filtroDataFim: format(endDate, "yyyy-MM-dd"),
    id_campanha: id,
  };
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/prospeccao/pessoasByIdCampanha",
    {
      params: objectParamsRequest,
    }
  );

  return response.data?.resposta;
};

export const listTabloidProducts = async (
  startDate: Date,
  endDate: Date,
  id: number
): Promise<any[]> => {
  const objectParamsRequest = {
    filtroDataInicio: format(startDate, "yyyy-MM-dd"),
    filtroDataFim: format(endDate, "yyyy-MM-dd"),
    id_campanha: id,
    grupoCampanha: "CONCLUIDO",
  };
  const response = await api.get(
    "sms-p1-:stage/:stage/crm/getProdutosTabloideCampanha",
    {
      params: objectParamsRequest,
    }
  );

  return response.data;
};

export const listDetailsResultCampaign = async (
  startDate: Date,
  endDate: Date,
  id: number
) => {
  const objectParamsRequest = {
    filtroDataInicio: format(startDate, "yyyy-MM-dd"),
    filtroDataFim: format(endDate, "yyyy-MM-dd"),
    idCampanha: id,
    grupoCampanha: "CONCLUIDO",
  };
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/performance/getDetalhesCampanha",
    {
      params: objectParamsRequest,
    }
  );

  return response.data;
};
